import React from 'react';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
import { NumberSelect, OfferFormItem, BankSelect } from '@/components';
import { Form, Input, Select, DatePicker, InputNumber } from '@whalecloud/fdx';

const { TextArea } = Input;
// 表单映射，后期可是情况扩展，目前只用到了这几个
const { RangePicker } = DatePicker;
const formItemType = {
  input: Input,
  select: Select,
  numberSelect: NumberSelect,
  date: DatePicker,
  textarea: TextArea,
  rangeData: RangePicker,
  offerSelectModal: OfferFormItem,
  inputNumber: InputNumber,
  bankSelect: BankSelect,
};

const { Option } = Select;

// 根据入参formItems，渲染表单项
function renderFormItems(formItems, getFieldDecorator, getFieldValue) {
  const filteredFormItems = formItems.filter(formItem => {
    // 联动，dynamic联动函数没通过(返回false)，则不展示当前这个表单控件
    if (formItem.dynamic && typeof formItem.dynamic === 'function' && !formItem.dynamic(getFieldValue)) {
      return false;
    }
    return true;
  });

  // 考虑到目前每行最多只渲染3个，所以当屏幕够大时（>1260）补全为3的倍数，当屏幕较小(<1260)只能显示两个时补全为2的倍数
  // 补全的formItem只做占位，样式中会通过opacity:0隐藏
  while ((window.innerWidth > 1260 && filteredFormItems.length % 3 !== 0) || (window.innerWidth < 1260 && filteredFormItems.length % 2 !== 0)) {
    filteredFormItems.push({ type: 'hidden' });
  }

  // 考虑一种情况：我就是不想补全，所以往入参formItems里添加了空对象，这种情况要把这个空数据给过滤掉
  return filteredFormItems.filter(item => item.type).map((formItem, index) => {
    const formItemProps = formItem.formItemProps || {}; // 传递给Form.Item的props
    const formItemCompProps = formItem.formItemCompProps || {}; // 传递给表单控件的props

    if (formItem.type !== 'hidden') {
      let FormItemComp = formItemType[formItem.type];
      if (formItem.type === 'select' && get(formItem, 'data.length') > 0) {
        if (!formItem.renderField) {
          FormItemComp = props => (
            <Select {...props} key={formItem.name}>
              {formItem.data.map(item => (
                <Option key={item} value={item} item={item}>
                  {item}
                </Option>
              ))}
            </Select>
          );
        } else {
          const { lableField, valueField } = formItem.renderField;
          FormItemComp = props => (
            <Select {...props} key={formItem.name}>
              {/* TODO option中的value具体对应的字段还待接口出来后再决定，尽量避免手动添加属性 */}
              {formItem.data.map(item => (
                <Option key={item[valueField]} value={item[valueField]} item={item}>
                  {item[lableField]}
                </Option>
              ))}
            </Select>
          );
        }
      }

      return (
        <Form.Item label={formItem.label} key={formItem.name} {...formItemProps}>
          {getFieldDecorator(formItem.name, formItem.options)(<FormItemComp {...formItemCompProps} />)}
        </Form.Item>
      );
    }
    return (
      <Form.Item className="formItemHidden" label="empty" key={(uniqueId('formItemHidden_'))}>
        {getFieldDecorator(`empty${index}`, {})(<Input type="hidden" />)}
      </Form.Item>
    );
  });
}

export { formItemType, renderFormItems };
